module.exports = __webpack_public_path__ + "static/media/logo-rms.81eccb5a.png";